import styled from "styled-components";

export const Container = styled.section`
    display: flex;
    margin-left: -4px;
    margin-top: 16px;
    flex-wrap: wrap;
`
export const LetterContainer = styled.div`
    margin-right: 10px;
    background-color: transparent;
    cursor: pointer;
    border-radius: ${({selected}) => selected ? '50%' : 'unset' };
    background: ${({selected}) => selected ? '#ff8d6a' : 'unset' };
    padding:4px;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const LetterTypography = styled.div`
    margin-left: 1px;
    font-size: 1.7vh !important;
    line-height: 30px;
    user-select: none;
    color: ${({selected}) => selected ? 'white' : ' #919194' };
    font-weight: ${({selected}) => selected ? 'bold' : '500' };
    text-align: center;
    font-family: Hind Vadodara, Lucida Sans Unicode !important;
    letter-spacing: 0.8px;
`